<ng-container *adaptLoading="!categories">
    @if (showExpandCollapseMenu) {
        <adapt-menu adaptToolbarContent
                    [items]="menuItems"></adapt-menu>
    }
    <dx-accordion [dataSource]="categories"
                  [collapsible]="true"
                  [multiple]="true"
                  [ngClass]="[
                      (!showExpandCollapseMenu || integratedOnly) ? 'container-accordion' : '',
                      personColorIndex !== undefined ? 'vision-person-color-border-' + (personColorIndex % 12) : '',
                      integratedOnly ? 'integrated-container' : ''
                  ]"
                  (onContentReady)="onContentReady($event)">
        <div *dxTemplate="let category of 'title'"
             class="d-flex justify-content-start align-items-center gap-2"
             [ngClass]="{'no-top-border': (!showExpandCollapseMenu || integratedOnly) && category === categories![0]}"
             [id]="'vision-category-' + (category?.visionCategoryId ?? 0)">
            @if (!personId && !integratedOnly) {
                <h2 class="my-0 d-flex align-items-center gap-1">
                    <ng-container *ngTemplateOutlet="categoryTitleTpl"></ng-container>
                </h2>
            } @else {
                <h3 class="my-0 d-flex align-items-center gap-1">
                    <ng-container *ngTemplateOutlet="categoryTitleTpl"></ng-container>
                </h3>
            }
            <ng-template #categoryTitleTpl>
                {{ category.name }}
                @if (!category.visionCategoryId && !personId && !integratedOnly) {
                    @let summary = getVisionsForCategory(0)[0];
                    @if (canEditTeamVision) {
                        <button adaptButton="editBorderless"
                                class="me-2 smaller-vision-button-text"
                                (click)="editIntegratedVision(0)"></button>
                    }

                    @if (summary?.extensions?.isCompleted) {
                        <ng-container *ngTemplateOutlet="showCompletedTick"></ng-container>
                    }
                } @else if (indicateIncompleteCategories) {
                    @let vision = getVisionsForCategory(category.visionCategoryId)[0];
                    @if (vision && !vision.extensions.isCompleted) {
                        @if (canEditTeamVision) {
                            <button class="btn btn-blank text-warning"
                                    adaptButtonIcon="fal fa-exclamation-triangle"
                                    adaptTooltip="This category is incomplete"
                                    (click)="editVision(vision)"
                                    adaptStopPropagation></button>
                        } @else {
                            <i class="fal fa-fw fa-exclamation-triangle text-warning"
                               adaptTooltip="This category is incomplete"></i>
                        }
                    }
                }
            </ng-template>
        </div>
        <div *dxTemplate="let category of 'item'"
             [ngClass]="{'pt-0': !personId && !integratedOnly, 'personal-vision-grouped-by-person': personId || integratedOnly}">
            @let visions = getVisionsForCategory(category.visionCategoryId);
            @if (visions.length === 1) {
                <div class="avoid-page-break-inside"
                     [ngClass]="{ 'integrated-vision-statement': visions[0].extensions.isIntegrated && !integratedOnly }">
                    <ng-container *ngTemplateOutlet="showVision; context: { $implicit: visions[0] }"></ng-container>
                </div>
            } @else if (visions.length === 0) {
                <div><b>No visions found for this category yet.</b></div>
            } @else {
                <div class="multi-visions-row">
                    <div class="multi-visions-row-personal"
                         [ngClass]="{
                            'person-count-1': visions.length <= 2,
                            'person-count-2': visions.length === 3,
                            'person-count-more': visions.length >= 4,
                        }">
                        @for (vision of visions; track vision.visionId; let i = $index) {
                            @if (vision.extensions.isPersonal) {
                                <div class="avoid-page-break-inside"
                                     [ngClass]="'personal-vision-statement-' + (i % 12)">
                                    <div class="d-flex gap-2 align-items-center">
                                        <b class="d-flex gap-1 align-items-center">
                                            <adapt-link-person [personId]="vision.personId"
                                                               [showImage]="true"
                                                               imageSize="sm"
                                                               [linkDisabled]="true"></adapt-link-person>
                                        </b>
                                        @if (canEditTeamVision) {
                                            <button adaptButton="editBorderless"
                                                    class="smaller-vision-button-text"
                                                    (click)="editVisionForPerson(vision.personId!, vision.visionCategoryId!)"></button>
                                        }
                                        @if (vision.extensions.isCompleted) {
                                            <ng-container *ngTemplateOutlet="showCompletedTick"></ng-container>
                                        }
                                    </div>
                                    <ng-container *ngTemplateOutlet="showVision; context: { $implicit: vision }"></ng-container>
                                </div>
                            }
                        }
                    </div>
                    <div class="multi-visions-row-integrated">
                        @let integratedVision = getIntegratedVision(visions);
                        @if (integratedVision?.statement || hasCompletedPersonalVision(integratedVision)) {
                            <div class="integrated-vision-statement h-100 avoid-page-break-inside">
                                <div class="d-flex gap-2 align-items-center">
                                    <b>Integrated Vision</b>
                                    @if (canEditTeamVision) {
                                        <button adaptButton="editBorderless"
                                                class="smaller-vision-button-text"
                                                (click)="editIntegratedVision(integratedVision!.visionCategoryId!)"></button>
                                    }
                                    @if (integratedVision!.extensions.isCompleted) {
                                        <ng-container *ngTemplateOutlet="showCompletedTick"></ng-container>
                                    }
                                </div>
                                <ng-container *ngTemplateOutlet="showVision; context: { $implicit: integratedVision }"></ng-container>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    </dx-accordion>
    @if (integratedVisionPersonId) {
        <div class="d-flex align-items-center gap-1 text-muted small mt-2 ms-auto">
            <adapt-link-person [personId]="integratedVisionPersonId"
                               [showImage]="false"></adapt-link-person>
            <span>is nominated to drive the integrated vision</span>
        </div>
    }
    @if (lastPublished) {
        <div class="text-muted small mt-2 ms-auto">
            Last published: {{ lastPublished | adaptDateTime }}
        </div>
    }

    <ng-template #showVision
                 let-vision>
        @if (!vision.statement) {
            @if (!vision.visionCategoryId) {
                <span class="text-muted small"><i>No vision summary has been defined yet.</i></span>
            } @else {
                <span class="text-muted small"><i>No vision statement has been defined for this category yet.</i></span>
            }
        } @else {
            <div class="d-flex flex-column gap-2 flex-grow-1">
                <div [froalaView]="vision.statement"></div>
                @if (vision.lastUpdated) {
                    <span class="mt-auto text-muted small">Last updated:
                        {{ vision.lastUpdated | adaptDateTime }}
                    </span>
                }
            </div>
        }
    </ng-template>

    <ng-template #showCompletedTick>
        <i class="ms-1 fal fa-fw fa-check text-success"
           adaptTooltip="Completed"></i>
    </ng-template>
</ng-container>
